import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Box from 'core/ui/Box';
import SelectorUser from 'components/Profile/SelectorUser';
import useSelectors from 'modules/map/useSelectors';
import { salesUsersChannelsModule } from 'modules/salesUsersChannels';
import Backdrop from 'core/ui/Backdrop';

const ModalSetUserAsSale = ({ modalAddUser, setModalAddUser, createSalesUser }) => {
  const loading = useSelectors(salesUsersChannelsModule, 'loadingForm');

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      open={modalAddUser?.open}
      onClose={() => setModalAddUser({ open: false })}
    >
      <Box>
        {loading && <Backdrop />}
        <SelectorUser onSelectedUser={(u) => createSalesUser(u)} />
      </Box>
    </Dialog>
  );
};

ModalSetUserAsSale.defaultProps = {
  close: () => {},
};

export default ModalSetUserAsSale;
